import { IMortgageBanner } from '../types/mortgageBanner';
import { IMortgageBannerPikContract } from '../repositories/special-promos-custom/entities/ContentBlocks/MortgageBannerPikContract';

export function prepareMortgageBanner(response: IMortgageBannerPikContract): IMortgageBanner {
  return {
    image: response.image,
    hitUrl: response.hitUrl,
    disclaimer: response.disclaimer,
  };
}
